export const PRIMARY_BACKGROUND_COLOR = "#F8F8F8";
export const PRIMARY_BORDER_COLOR = "#e4e2e2";
export const SNOW = "#FFF";
export const PRIMARY_BUTTON_COLOR = "#0600FF";
export const WEAK_FONT_COLOR = "#888";